var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserVerifyAge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 160,
    width: 320,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.214 30.91h88.462c2.006 0 2.733.21 3.467.601a4.089 4.089 0 0 1 1.7 1.701c.393.734.602 1.461.602 3.467v88.803c0 2.006-.209 2.734-.601 3.467a4.089 4.089 0 0 1-1.701 1.701c-.734.392-1.461.601-3.467.601h-88.462c-2.006 0-2.734-.209-3.467-.6a4.089 4.089 0 0 1-1.701-1.702c-.392-.733-.601-1.46-.601-3.467V36.68c0-2.006.209-2.733.6-3.467a4.089 4.089 0 0 1 1.702-1.7c.733-.393 1.46-.602 3.467-.602z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.445 30.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.38 89.829c4.18-11.94 13.046-19.55 22.783-19.56H59.7c10.562-.001 18.898 6.133 22.553 19.588z",
    fill: "#bdc1cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.798 31.994c2.828-9.01 9.257-17.274 18.15-20.323 8.891-3.048 24.404-.199 28.597 8.257 6.043 12.186 3.328 27.11.124 40.34a321.354 321.354 0 0 0-5.051-.22l-2.393-7.975v7.896c-13.2-.409-26.945-.153-40.695.111-1.23-9.365-1.56-19.075 1.268-28.086z",
    fill: "#9ea6b5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.172,
    cy: 40.755,
    fill: "#fff",
    r: 20.244
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.967 16.364A23.953 23.953 0 0 1 69.385 37.27c-10.66.49-21.859.618-33.213.64l-2.685-6.569-1.582 6.573c-3.46 0-6.927-.005-10.4-.014a24.458 24.458 0 0 1 11.462-21.536z",
    fill: "#9ea6b5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.595 59.414V37.983h21.431m-21.431 49.368v21.432h21.431m50.269-49.369V37.983h-21.431m21.431 49.368v21.432h-21.431",
    stroke: "#061437",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.795,
    cy: 112.91,
    fill: "#061437",
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.556 123.584a2.001 2.001 0 0 1-2.01-2.01c0-1.132.893-1.993 2.01-1.993 1.132 0 1.993.861 1.993 1.994-.016 1.1-.861 2.009-1.993 2.009zm4.8-11.801c-1.212 1.77-2.36 2.329-2.983 3.46-.159.288-.255.511-.303 1.005-.08.718-.717 1.244-1.435 1.244h-.095a1.4 1.4 0 0 1-1.404-1.53c.048-.543.176-1.101.479-1.643.781-1.388 2.264-2.217 3.125-3.445.91-1.291.399-3.715-2.184-3.715-1.133 0-1.882.574-2.345 1.26-.398.574-1.1.845-1.754.574a1.39 1.39 0 0 1-.638-2.09c.973-1.419 2.6-2.455 4.705-2.455 2.36 0 3.97 1.068 4.8 2.424.701 1.148 1.116 3.3.032 4.911z",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserVerifyAge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-verify-age.edcdb9d4f96c21be7b7a73d3b6959fbe.svg";